import type { LoginLayoutMedia } from '@ksyos/design-system';
import { Box, KsyosLogo, Link, LoginLayout, Text } from '@ksyos/design-system';
import { useSearchParams } from '@ksyos/router';
import { ForgotPassword } from './ForgotPassword';
import { ForgotUsername } from './ForgotUsername';
import { MainNotLoggedInViews } from './MainNotLoggedInViews';
import { NewLogin } from './NewLogin';

const media: LoginLayoutMedia = {
    sources: [
        {
            srcSet: [
                { scale: '1x', source: '/assets/images/login/login@1x.webp' },
                { scale: '2x', source: '/assets/images/login/login@2x.webp' },
            ],
            type: 'webp',
        },
        {
            srcSet: [
                { scale: '1x', source: '/assets/images/login/login@1x.jpg' },
                { scale: '2x', source: '/assets/images/login/login@2x.jpg' },
            ],
            type: 'jpg',
        },
    ],
};

export function MainNotLoggedIn() {
    const [searchParams] = useSearchParams();
    const view = searchParams.getOptional('view');
    const token = searchParams.getOptional('token');

    let content;
    if (!view && !token) {
        content = <NewLogin />;
    } else {
        switch (view) {
            case 'login':
                content = <NewLogin />;
                break;
            case 'forgotUsername':
                content = <ForgotUsername />;
                break;
            case 'forgotPassword':
                content = <ForgotPassword />;
                break;
            default:
                content = (
                    <MainNotLoggedInViews
                        token={token}
                        viewName={view}
                    />
                );
        }
    }

    return (
        <LoginLayout
            media={media}
            slogan="Maakt de zorg slimmer, beter en menselijker"
        >
            <KsyosLogo />
            {content}
            <LoginLayout.Divider text="Nog vragen?" />
            <Box
                alignItems="center"
                display="flex"
                flexDirection="column"
                gap={6}
            >
                <Link
                    color="secondary"
                    href="https://ksyos.nl/aanvragen-wijzigen-account/"
                    variant="externalLink"
                >
                    Vraag zelf een account aan
                </Link>
                <Link
                    color="secondary"
                    href="https://ksyos.nl/his-koppelingen"
                    variant="externalLink"
                >
                    Eenvoudig inloggen via je HIS
                </Link>
                <Link
                    color="secondary"
                    href="https://ksyos.nl/faq/"
                    variant="externalLink"
                >
                    Veelgestelde vragen
                </Link>
            </Box>
            <Text
                size="xs"
                sx={{ marginTop: 'auto' }}
                textAlign="center"
            >
                Het Ksyos platform bevat persoonlijke gezondheidsinformatie. Deze informatie is vertrouwelijk.
            </Text>
        </LoginLayout>
    );
}
